<template lang="html">
  <div class="item-cells product-label" v-if="newExp.length > 0">
    <div class="item-cell" @click="showLabels">
      <ul class="item-cell-bd">
        <li
          v-for="explanation in newExp"
          :class="{ active: explanation.isGood === 1 }"
        >
          <span>
            <i
              v-if="explanation.isGood === 1"
              class="iconfont icon-roundcheck"
            ></i>
            <i v-else class="iconfont icon-roundcheck guanbi"></i
            ><span>{{ explanation.title }}</span>
          </span>
        </li>
      </ul>
      <div class="item-cell-ft">
        <img class="icon-more" src="../../assets/images/icon-more.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import PROUDCT_TYPE from '@/router/home/components/product/product-intro/config'

export default {
  props: {
    product: {
      type: Object
    }
  },
  computed: {
    ...mapState(['serveExplanation']),
    newExp() {
      const lb = []
      if (
        this.product.isAnyTimeRefund === 0 &&
        this.product.isExpiredRefund === 0
      ) {
        lb.push({ title: '不可退', isGood: 0 })
      } else {
        if (this.product.isAnyTimeRefund === 1) {
          lb.push({ title: '随时退', isGood: 1 })
        }
        if (this.product.isExpiredRefund === 1) {
          lb.push({ title: '过期退', isGood: 1 })
        }
      }
      // }
      // if (this.product.isSchedule * 1 === 1) {
      //     lb.push({ title: '需预约', isGood: 1 })
      // } else {
      //     lb.push({ title: '免预约', isGood: 1 })
      // }
      if (this.product.isPosPay * 1 === 1) {
        lb.push({ title: 'POS支付', isGood: 1 })
      }
      if (+this.product.spuType === PROUDCT_TYPE.YU_ER)
        lb.push({ title: 'PICC承保', isGood: 1 })
      return lb
    }
  },
  methods: {
    // showActionsheet() {
    //     this.$store.commit('showActionSheet')
    // },
    ...mapMutations(['showActionSheet', 'changeView', 'setActionHeader']),
    showLabels() {
      this.changeView('serveExplain')
      this.setActionHeader({
        title: '服务说明'
      })
      this.showActionSheet()
      this.$$tracker('100101', '20000', 21001)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.product-label {
  padding: 0 rem(20px);
  background: #fff;
  .item-cell {
    padding: 0 0 rem(30px) 0;
  }
  .icon-more {
    color: #666;
  }
  li {
    display: inline-flex;
    align-items: center;
    position: relative;
    margin-right: rem(40px);
    font-size: rem(24px);
    color: #999;

    .iconfont {
      vertical-align: middle;
      margin-right: rem(4px);
      font-size: rem(32px);
    }
    .icon-roundcheck {
      color: #ff397e;
    }
    .guanbi {
      color: #666;
    }
    &.active {
      color: #666;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .item-cell-bd {
    height: 1.4em;
    // line-height: rem(30px);
    margin-right: rem(20px);
    margin-top: rem(2px);
    overflow: hidden;
  }
  .icon-more {
    width: rem(32px);
    height: rem(30px);
  }
}
</style>
